import React from 'react';
import { Container, TabContent, TabPane, Row, Col, Nav, NavItem, NavLink } from "reactstrap";
import classnames from 'classnames';

class About extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: '1'
    };
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  render() {
    return (
    <div>
      <Container>
        <Nav tabs>
          <NavItem>
            <NavLink className={classnames({ active: this.state.activeTab === '1' })}
                     onClick={() => { this.toggle('1'); }}>
              Contact
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="1">
             <Contact/>
          </TabPane>            
        </TabContent>
        </Container>
    </div>)
  }
}

class Contact extends React.Component {
  render() {
    return(
      <div>
      <Row style={{margin:"25px 0px"}}>
        <Col>
          <Row>
          email     : AndryRajoelimanana@gmail.com
          </Row> 
          <Row>
          Phone     : +1 202 823 6126 
          </Row>
          <Row>
          Arlington, Virginia, USA
          </Row>
          <Row>
          Linkedin  : <a href="https://www.linkedin.com/in/andryrajoelimanana/">https://www.linkedin.com/in/andryrajoelimanana</a> 
          </Row>
          <Row>
          Github    : <a href="https://github.com/AndryRajoelimanana/">https://github.com/AndryRajoelimanana/</a> 
          </Row>
        </Col>
      </Row>
      <Row>
        <Col>
        <p style={{paddingBottom:"300px"}}></p>
        </Col>
      </Row>
      </div>  
    )
  }
}

export default About;